import {hasFeatureToggle} from 'lib/FeatureToggle'
import {OBIE as OBIE_FLAG} from 'auth/user/flags'
import React from 'react'
import Card from 'organization/Event/Services/Apps/Card'
import obieLogo from 'organization/Event/Services/Apps/Obie/logo.png'
import {useEventRoutes} from 'organization/Event/EventRoutes'
import {OBIE} from 'organization/Event/Services/ServicesProvider'
import {useOwner} from 'organization/OwnerProvider'

export default function ObieCard() {
  const routes = useEventRoutes()
  const {owner} = useOwner()

  if (!hasFeatureToggle(owner, OBIE_FLAG)) {
    return null
  }

  return (
    <Card
      service={OBIE}
      label="Obie"
      link={routes.services.obie}
      logo={obieLogo}
      color="#FFFFFF"
    />
  )
}
